"use client"

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Brain, Zap, Shield, Code, BarChart, Globe } from "lucide-react"
import { useLanguage } from "@/lib/i18n/language-context"

export function FeaturesSection() {
  const { t } = useLanguage()

  const features = [
    {
      icon: Brain,
      title: t.advancedModels,
      description: t.advancedModelsDesc,
    },
    {
      icon: Zap,
      title: t.fastProcessing,
      description: t.fastProcessingDesc,
    },
    {
      icon: Shield,
      title: t.absoluteSecurity,
      description: t.absoluteSecurityDesc,
    },
    {
      icon: Code,
      title: t.easyAPI,
      description: t.easyAPIDesc,
    },
    {
      icon: BarChart,
      title: t.detailedAnalytics,
      description: t.detailedAnalyticsDesc,
    },
    {
      icon: Globe,
      title: t.multiLanguage,
      description: t.multiLanguageDesc,
    },
  ]

  return (
    <section id="features" className="px-4 py-20 md:px-6 md:py-32">
      <div className="container mx-auto">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-balance text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
            {t.featuresTitle}
          </h2>
          <p className="mx-auto max-w-2xl text-pretty text-lg text-muted-foreground">{t.featuresSubtitle}</p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <Card key={feature.title} className="border-border/50 transition-shadow hover:shadow-lg">
              <CardHeader>
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                  <feature.icon className="h-6 w-6 text-primary" />
                </div>
                <CardTitle className="text-xl">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base leading-relaxed">{feature.description}</CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
